import { Button } from "@/components/ui/button";
import HelioLogoMark from "@/components/HelioLogoMark";
import { Home, ArrowLeft } from "lucide-react";
import { useLocation } from "wouter";
import { useEffect } from "react";
import { trackPage404 } from "@/analytics";

export default function NotFound() {
  const [location, setLocation] = useLocation();

  useEffect(() => {
    trackPage404(location);
  }, [location]);

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[#050d1a] px-4">
      <div className="w-full max-w-lg text-center">
        <HelioLogoMark className="text-4xl mx-auto mb-8" style={{ color: "#29ffa9" }} />

        <p className="font-mono text-xs text-[#29ffa9]/70 uppercase tracking-wider mb-2">404</p>
        <h1 className="text-3xl sm:text-4xl font-semibold text-white mb-3">Page not found</h1>
        <p className="text-white/60 mb-8 leading-relaxed">
          Sorry, the page you are looking for doesn&apos;t exist or may have been moved.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            onClick={() => setLocation("/")}
            className="bg-[#29ffa9] text-[#050d1a] hover:bg-[#29ffa9]/90 px-6"
          >
            <Home className="w-4 h-4 mr-2" />
            Back to homepage
          </Button>
          <Button
            variant="outline"
            onClick={() => window.history.back()}
            className="border-white/15 text-white/70 hover:text-white hover:bg-white/5"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Go back
          </Button>
        </div>
      </div>
    </div>
  );
}
